import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Switch as ChakraSwitch,
} from '@chakra-ui/react';
import React from 'react';
import { get } from 'lodash';
import { useFormContext } from 'react-hook-form';


const Switch = ({ label, name, ...inputProps }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const errorMessage = get(errors, name)?.message;

  return (
    <FormControl
      isInvalid={errorMessage}
      mb={4}
      display="flex"
      alignItems="center"
    >
      <ChakraSwitch {...register(name)} colorScheme="blue" {...inputProps} />
      <FormLabel ml={2} htmlFor={name}>{label}</FormLabel>
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
};

export default Switch;
